import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined"
import GridViewIcon from "@mui/icons-material/GridView"
import { CARD_VIEW, TABLE_VIEW } from "hooks/dashboard/useDashboardComponent"

const viewOptions = [
  {
    key: CARD_VIEW,
    icon: <GridViewIcon className="dashboardIcon" />,
    label: "Vista de Tarjetas",
  },
  {
    key: TABLE_VIEW,
    icon: <FormatListBulletedOutlinedIcon className="dashboardIcon" />,
    label: "Vista de Tabla",
  },
]

const DashboardComponentIconMenu = ({ viewSelected, setViewMode }) => {
  return (
    <div className="dashboardSwitchVista">
      {viewOptions.map(({ key, icon, label }) => (
        <div
          key={key}
          className={classNames("dashboardIconView", {
            selected: viewSelected === key,
          })}
          onClick={() => setViewMode(key)}
          aria-label={label}
          role="button"
          tabIndex={0}
        >
          {icon}
        </div>
      ))}
    </div>
  )
}

DashboardComponentIconMenu.propTypes = {
  viewSelected: PropTypes.number.isRequired,
  setViewMode: PropTypes.func.isRequired,
}

export default DashboardComponentIconMenu
